import { ConnectionToRemotePeer } from "./connectionToRemotePeer";

export class HostReconnect {
	/** We have stopped trying, and only a retry will start again. Read by the host's banner. */
	failed = false;
	private inFlight = false;
	private cancelled = false;

	constructor(
		private connection: ConnectionToRemotePeer,
		private onChanged: (peerConnected: boolean) => void
	) { }

	onClosed(intentional: boolean) {
		if (this.cancelled) return;
		this.onChanged(false);
		if (intentional) return; //they meant to go, so there is nobody to wait for
		this.attempt();
	}

	retry() {
		this.attempt();
	}

	cancel() {
		this.cancelled = true;
		this.failed = false;
	}

	private async attempt() {
		if (this.inFlight || this.cancelled) return;
		this.inFlight = true;
		this.failed = false;
		this.onChanged(false);

		const reconnected = await this.connection.reconnectWithRetry();

		this.inFlight = false;
		if (this.cancelled) return;
		//Once we stop trying the player has to be told, or the waiting message becomes a lie
		this.failed = !reconnected;
		this.onChanged(reconnected);
	}
}
